// deps
import React from "react";

// internal-deps
import { DELIVERY_SECTION_ELEMENT } from "@swiggy-private/checkout-core";
import { DeliveryInstructionCroutonDetail } from "@swiggy-private/cart-types";

export interface DeliverySectionContextValue {
    selectedOption: DELIVERY_SECTION_ELEMENT | null;
    onTabChange: (selectedOption: DELIVERY_SECTION_ELEMENT) => void;
    setDeliveryTab: (selectedOption: DELIVERY_SECTION_ELEMENT, shouldScrollToTab?: boolean) => void;
    deliveryModeInfo: {
        isDeliverySpeedCroutonActive: boolean;
        canShowDeliverySpeedCrouton: boolean;
        setDeliverySpeedCroutonActive: (isDeliverySpeedCroutonActive: boolean) => void;
    };
    deliveryInstructionsInfo: {
        canShowDeliveryInstructionCrouton: boolean;
        deliveryInstructionCroutonDetail?: DeliveryInstructionCroutonDetail;
    };
}

export const DeliverySectionContext = React.createContext<DeliverySectionContextValue>({
    selectedOption: DELIVERY_SECTION_ELEMENT.DELIVERY_TYPE,
    onTabChange: () => void 0,
    setDeliveryTab: () => void 0,
    deliveryModeInfo: {
        isDeliverySpeedCroutonActive: false,
        canShowDeliverySpeedCrouton: false,
        setDeliverySpeedCroutonActive: () => void 0,
    },
    deliveryInstructionsInfo: {
        canShowDeliveryInstructionCrouton: false,
    },
});

if (__DEV__) {
    DeliverySectionContext.displayName = "DeliverySectionContext";
}
